import Marquee from "react-fast-marquee";

export default function Aluminis() {
  return (
    <section className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(45rem_50rem_at_top,var(--color-indigo-100),white)] opacity-20" />
      <div className="absolute inset-y-0 right-1/2 -z-10 mr-16 w-[200%] origin-bottom-left skew-x-[-30deg] bg-white ring-1 shadow-xl shadow-indigo-600/10 ring-indigo-50 sm:mr-28 lg:mr-0 xl:mr-16 xl:origin-center" />
      <div className="mx-auto max-w-2xl lg:max-w-4xl">
        <h1 className="text-center font-bold text-2xl">Distinguished Alumni</h1>
        <figure className="mt-10">
          <blockquote className="text-center text-xl/8 font-semibold text-gray-900 sm:text-2xl/9">
            <p className="text-justify text-lg">
              “Distinguished alumni are individuals who have made significant
              contributions to their fields, communities, or society, bringing
              honor and recognition to their alma mater. Through their
              leadership, innovation, and dedication, they serve as role models
              for current and future students, demonstrating the impact of
              education and perseverance. Whether excelling in business,
              academia, the arts, public service, or other domains, these alumni
              embody the values and mission of their institution. Their
              achievements often inspire and create opportunities for others,
              reinforcing the legacy of excellence associated with their
              educational journey.”
            </p>
          </blockquote>
        </figure>
      </div>
      <Marquee>
        <div className="flex w-full flex-wrap flex-row items-center justify-center gap-x-20">
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://cdnbbsr.s3waas.gov.in/s3ec0490f1f4972d133619a60c30f3559e/uploads/2023/12/2023120870.jpg"
              className="mx-auto size-36 rounded-full"
              style={{ objectFit: "cover" }}
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Hon'ble Justice Doraiswamy Raju
              </div>

              <div className="text-gray-600">Former Judge, Supreme Court</div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://d2ur5c32qiu6z6.cloudfront.net/feed/emembersv1/rpsj.jpg"
              style={{ objectFit: "cover" }}
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Hon'ble Justice R. Subbiah
              </div>

              <div className="text-gray-600">CEO of Workcation</div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/1.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. Carani B. Sanjeevi
              </div>

              <div className="text-gray-600">
                Professor, Department of  ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/2.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. Mohamed Rela
              </div>

              <div className="text-gray-600">
                Indian Surgeon known ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/3.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. Kadharbatcha S Saleem
              </div>

              <div className="text-gray-600">
                Scientist at the Nation ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/4.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. D. Narayana Reddy
              </div>

              <div className="text-gray-600">Sexual Medicine Specialist</div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/5.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">Mr. T.R. Baalu</div>

              <div className="text-gray-600">
                Former Cabinet Minister ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/6.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">Mr. G. K. Vasan</div>

              <div className="text-gray-600">
                Former Union Minister ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/7.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">Mr. W. V. Raman</div>

              <div className="text-gray-600">
                former Indian cricketer ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/8.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. Sultan Ahmed Ismail
              </div>

              <div className="text-gray-600">
                INDIAN SOIL BIOLOGIST ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/9.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Mr. Mohammed Afzal Quraishi
              </div>

              <div className="text-gray-600">
                CEO, MULTI ROLE TRANSPORT ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://imgs.search.brave.com/UsjBDy-JYehf0TLFpu_yeLKXxyWt2XVU1gJTduo5J1I/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzViL2Jm/LzY3LzViYmY2N2Yw/ZjAxNDY3MjIyZTYw/MTRkNGIxYjMxN2M0/LmpwZw"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Mr. Shiva Rajkumar
              </div>

              <div className="text-gray-600">
                 An Indian film actor ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/11.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">Mr. Radha Ravi</div>

              <div className="text-gray-600">Cinema Actor</div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/12.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Dr. M.H. Jawahirullah
              </div>

              <div className="text-gray-600">
                Ex-MLA & Party President ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/13.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Mr. Sarath Kumar
              </div>

              <div className="text-gray-600">
                Ex-MLA, Actor & ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/14.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Mr .Afroze Ahamad Madhar Sahib{" "}
              </div>

              <div className="text-gray-600">
                Senior Technology Architect ...
              </div>
            </div>
          </figcaption>
          <figcaption className="mt-10">
            <img
              alt=""
              src="https://sedge.in/img/15.png"
              className="mx-auto size-36 rounded-full"
            />
            <div className="mt-4 flex items-center flex-col justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">
                Mr. Mehboob Basha
              </div>

              <div className="text-gray-600">
                Indian Foreign Service ...
              </div>
            </div>
          </figcaption>
        </div>
      </Marquee>
    </section>
  );
}
